import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationGroup7MasterReferenceData = createAsyncThunk(
  'stop/getVerificationGroup7MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationGroup7MasterReferenceSlice = createSlice({
  name: 'stop/verificationGroup7MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationGroup7MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationGroup7MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationGroup7MasterReference } =
  verificationGroup7MasterReferenceSlice.actions;

export default verificationGroup7MasterReferenceSlice.reducer;
